import { types } from "../types/types";

export const menuActiveReducer = (state = {}, action) => {
    switch (action.type) {
        case types.menuActive:
            return {
                data: action.payload,
            }
        default:
            return state;
    }
}

